import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { State } from '../models/state.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private apiUrl = environment.apiUrl + environment.statePath;

  constructor(private http: HttpClient) {}

  getStates(): Observable<State[]> {
    return this.http.get<State[]>(this.apiUrl);
  }
}
